import { isNullOrWhitespace } from "utilities/string/string";

import {
    type AddressEntity,
    type AddressFormValues,
    getBottomAddressForMapToolTip,
} from "commonComponents/entity/address/Address/Address.api.types";

interface IAddressMapTooltipProps {
    address: AddressEntity;
    formValues?: AddressFormValues;
}

const AddressMapTooltip = (props: IAddressMapTooltipProps) => {
    const { address, formValues } = props;
    const { street } = formValues || {};
    let formattedAddress = <></>;
    if (!isNullOrWhitespace(street)) {
        formattedAddress = <div>{street}</div>;
    }

    const formattedBottomAddress = getBottomAddressForMapToolTip(address);

    if (formattedBottomAddress.length > 0) {
        formattedAddress = (
            <>
                {formattedAddress}
                <div>{formattedBottomAddress}</div>
            </>
        );
    }

    return formattedAddress;
};

export default AddressMapTooltip;
